/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SessionSimpleDataModel } from '../../models/session-simple-data-model';

export interface GetPatientSessionSimpleList$Params {
  patientID?: number;
}

export function GetPatientSessionSimpleList(http: HttpClient, rootUrl: string, params?: GetPatientSessionSimpleList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SessionSimpleDataModel>>> {
  const rb = new RequestBuilder(rootUrl, GetPatientSessionSimpleList.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SessionSimpleDataModel>>;
    })
  );
}

GetPatientSessionSimpleList.PATH = '/api/Staff/GetPatientSessionSimpleList';
